import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const RectangleIcon = (props: SvgProps) => (
  <Svg
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <Path
      stroke="#0058AD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.667 4.667v6.666M3.333 4.667v6.666m8-8H4.667m6.666 9.334H4.667m-1.6-8H3.6c.373 0 .56 0 .703-.073a.667.667 0 0 0 .291-.291c.073-.143.073-.33.073-.703v-.533c0-.374 0-.56-.073-.703a.667.667 0 0 0-.291-.291C4.16 2 3.973 2 3.6 2h-.533c-.374 0-.56 0-.703.073a.667.667 0 0 0-.291.291C2 2.507 2 2.694 2 3.067V3.6c0 .373 0 .56.073.703a.667.667 0 0 0 .291.291c.143.073.33.073.703.073Zm0 9.333H3.6c.373 0 .56 0 .703-.073a.667.667 0 0 0 .291-.291c.073-.143.073-.33.073-.703V12.4c0-.373 0-.56-.073-.703a.667.667 0 0 0-.291-.291c-.143-.073-.33-.073-.703-.073h-.533c-.374 0-.56 0-.703.073a.667.667 0 0 0-.291.291C2 11.84 2 12.027 2 12.4v.533c0 .374 0 .56.073.703a.667.667 0 0 0 .291.291c.143.073.33.073.703.073ZM12.4 4.667h.533c.374 0 .56 0 .703-.073a.667.667 0 0 0 .291-.291C14 4.16 14 3.973 14 3.6v-.533c0-.374 0-.56-.073-.703a.667.667 0 0 0-.291-.291C13.493 2 13.306 2 12.933 2H12.4c-.373 0-.56 0-.703.073a.667.667 0 0 0-.291.291c-.073.143-.073.33-.073.703V3.6c0 .373 0 .56.073.703a.667.667 0 0 0 .291.291c.143.073.33.073.703.073Zm0 9.333h.533c.374 0 .56 0 .703-.073a.667.667 0 0 0 .291-.291c.073-.143.073-.33.073-.703V12.4c0-.373 0-.56-.073-.703a.667.667 0 0 0-.291-.291c-.143-.073-.33-.073-.703-.073H12.4c-.373 0-.56 0-.703.073a.667.667 0 0 0-.291.291c-.073.143-.073.33-.073.703v.533c0 .374 0 .56.073.703a.667.667 0 0 0 .291.291c.143.073.33.073.703.073Z"
    />
  </Svg>
);
export default RectangleIcon;
